import ClientManagementStore from "../../modules/Admin/ClientManagement/store";
import { ClientCategoryDto } from "../../modules/Admin/ClientManagement/types";
import { MessageResultState } from "../../types/general-types";
import { notifyPortalDataChanged } from "./portalData";

/**
 * Kategori listesi için tek giriş noktası; `userClients.ts` ile aynı gerekçe: dört tüketici
 * var ve bir kısmı aynı commit'te mount oluyor, uçuştaki istek paylaşılır. Sonuç önbelleğe
 * ALINMAZ, kategoriler yönetim panelinden değiştirilebiliyor. `invalidate` bekleyen isteği de
 * düşürür.
 */
let pending: Promise<ClientCategoryDto[]> | null = null;

export function fetchClientCategories(): Promise<ClientCategoryDto[]> {
  if (pending) return pending;

  pending = new ClientManagementStore()
    .getAllCategories()
    .then((response) => {
      pending = null;
      // Hata toast'ını axios interceptor basıyor; burada liste boş kalır.
      if (response?.state !== MessageResultState.SUCCESS) return [];
      return response.result || [];
    })
    .catch(() => {
      pending = null;
      return [];
    });

  return pending;
}

export function invalidateClientCategories(): void {
  pending = null;
  notifyPortalDataChanged();
}
